import { makeAutoObservable, toJS } from "mobx";
import clipIdStore from "@/stores/previewStore/clipId";
import { Message } from '@arco-design/web-react'
type TimelineData = {
  timeline: {
    VideoTracks: any[],
    FECanvas: {
      Width: number,
      Height: number
    }
  }
}
export const aspectObj = {
  '9:16': {
    width: '360',
    height: '640'
  },
  '16:9': {
    width: '640',
    height: '360'
  },
  '3:4': {
    width: '360',
    height: '480'
  },
  '4:3': {
    width: '480',
    height: '360'
  },
  '1:1': {
    width: '360',
    height: '360'
  }
}
export const getScale = (width, height, aspect) => {
  const scale = width / height
  let radio = null
  if (aspect === '9:16') {
    radio = 9 / 16
  } else if (aspect === '16:9') {
    radio = 16 / 9
  } else if (aspect === '1:1') {
    radio = 1
  } else if (aspect === '4:3') {
    radio = 4 / 3
  } else if (aspect === '3:4') {
    radio = 3 / 4
  }
  const sh = radio / scale * 0.5
  return sh
}


class YsVideoStore {
  shape = "horizontal"
  id = null
  name = "" // 模板名称
  folder_id = null // 文件夹id
  sort = "custom"
  width = "1080" // 视频宽
  height = "1920" // 视频高
  source_file_id = null
  image_name = ""
  url = ""
  AspectRatio = "9:16"
  timeline: TimelineData = {
    timeline: {
      VideoTracks: [],
      FECanvas: {
        "Width": 253.125,
        "Height": 450
      }
    }
  }
  previewData: unknown[] = []
  ratio = "9:16"
  stepIndex = 0
  selectType = 'Text'
  stepList: TimelineData[] = []
  lockList: { id: number, lock: boolean }[] = []
  customList: { id: number; coverType: number; customList?: any[] }[] = [];
  captions = []
  captionId = null // 字幕
  fontList = []
  playerRef: any = null
  constructor() {
    makeAutoObservable(this);
  }

  // 切换锁定状态
  toggleClipLock(clipId: number) {
    const item = this.lockList.find(item => item.id === clipId);
    if (item) {
      item.lock = !item.lock;
    } else {
      this.lockList.push({ id: clipId, lock: true });
    }
  }

  // 查询锁定状态
  isClipLocked(clipId: number): boolean {
    const item = this.lockList.find(item => item.id === clipId);
    return item ? item.lock : false;
  }

  // 记录当前 timeline 快照
  recordStep() {
    this.stepList.push(toJS(this.timeline));
    this.stepIndex = this.stepList.length - 1;
    console.log(JSON.stringify(this.stepList), 'stepList')
  }

  // 上一步
  prevStep() {
    if (this.stepIndex > 0) {
      this.stepIndex--;
      this.timeline = toJS(this.stepList[this.stepIndex]);
    }
  }

  // 下一步
  nextStep() {
    if (this.stepIndex < this.stepList.length - 1) {
      this.stepIndex++;
      this.timeline = toJS(this.stepList[this.stepIndex]);
    }
  }

  initTimeline(callback: any) {
    this.timeline.timeline.VideoTracks = [
      {
        "Id": Date.now() + parseInt(String(Math.random() * 10000)),
        "Type": "Video",
        "VideoTrackClips": []
      }
    ]
    setTimeout(() => {
      callback()
    }, 1000)
  }

  // 批量初始化图片
  public initImage(params: any[]) {
    if (!this.AspectRatio) {
      Message.warning('请先选择横屏或者竖屏组件!')
      return
    }
    const findImgFlag = this.timeline.timeline.VideoTracks.find(item => item.Type === "Image")
    if (findImgFlag) {
      this.timeline.timeline.VideoTracks.forEach((item) => {
        if (item.Type === "Image") {
          params.forEach((img: any, idx) => {
            console.log(img, 'img')
            const sh = getScale(img.width, img.height, '9:16')
            const id = Date.now() + parseInt(String(Math.random() * 10000));
            item.VideoTrackClips.push({
              "Id": id,
              "Type": "Image",
              "MediaId": img.MediaId,
              "MediaURL": img.MediaURL,
              "X": Number(0.1 * (idx)),
              "Y": Number(0.1 * (idx)),
              "AdaptMode": "Fill",
              "Width": 0.5,
              "Height": sh,
              "TimelineIn": 0,
              "TimelineOut": 20,
              "Duration": 20,
              "Speed": 1,
              "W": img.width,
              "H": img.height,
              "TrackId": id,
              "Name": img.Name
            });
            this.selectType = 'Image'
            setTimeout(() => {
              clipIdStore.setClipId(id)
            }, 1000)
          })
        }
      })
    } else {
      params.forEach((img, idx) => {
        const sh = getScale(img.width, img.height, '9:16')
        const id = Date.now() + parseInt(String(Math.random() * 10000));
        this.playerRef.addClip({
          Id: id,
          Type: "Image",
          ...(img?.MediaId && !img?.MediaURL
            ? { MediaId: img?.MediaId }
            : {}),
          ...(img?.MediaURL ? { MediaURL: img?.MediaURL } : {}),
          X: Number(0.1 * (idx)),
          Y: Number(0.1 * (idx)),
          AdaptMode: "Fill",
          Width: 0.5,
          Height: sh,
          timelineIn: 0,
          timelineOut: 20,
          Duration: 20,
          Speed: 1,
          W: img.width,
          H: img.height,
          TrackId: id,
          Name: img.Name
        })
      })
      this.timeline.timeline = this.playerRef.timeline
    }
  }

  public initVideo(params: any, type: 'horizontal' | 'vertical') {
    // 添加新的视频片段
    const id = Date.now() + parseInt(String(Math.random() * 10000));
    this.playerRef.addClip({
      "Id": id,
      "Type": "Video",
      "MediaId": params?.MediaId,
      "MediaURL": params?.MediaURL,
      "X": params.X,
      "Y": params.Y,
      "AdaptMode": "Contain",
      "Width": params.Width,
      "Height": params.Height,
      "In": 1,
      "Out": 1,
      "TimelineIn": 0,
      "TimelineOut": 20,
      "Duration": 20,
      "Speed": 1,
      "W": params.Width,
      "H": params.Height,
      "TrackId": id,
      "Name": params.Name || "Video Clip"
    });
    this.selectType = 'Video';
    this.recordStep();
    // 设置当前选中的片段
    setTimeout(() => {
      clipIdStore.setClipId(id);
    }, 1000);
  }

  // 初始化文字
  public initText(params: any, type = 0) {
    const Id = Date.now() + parseInt(String(Math.random() * 10000))
    const url = this.fontList.find(item => item.value === params?.Font)?.url;
    console.log(url, this.fontList, params, '字体Url')
    this.playerRef.addClip({
      Id: Id,
      Type: "Text",
      X: 0.5,
      Y: params?.Y || 0.5,
      Content: params?.Content || "占位文本",
      Alignment: "Center",
      FontSize: params?.FontSize || 40,
      FontColor: "#ffffff",
      FontColorOpacity: 1,
      EffectColorStyle: "",
      FontUrl: url,
      FontFace: {
        Bold: false,
        Italic: false,
        Underline: false
      },
      TimelineIn: 0,
      TimelineOut: 20,
      Spacing: 0,
      LineSpacing: 0,
      Angle: 0,
      SubtitleEffects: [
        {
          "Bord": null,
          "Color": "",
          "Type": "Shadow" // 阴影宽度
        },
        {
          "Bord": null,
          "Color": "",
          "Type": "Outline" // 描边宽度
        }
      ],
      AdaptMode: "AutoWrap",
      Duration: 20,
      SizeRequestType: "RealDim",
      BorderStyle: 1,
      TrackId: Id,
      TextWidth: 0.8,
      AaiMotionInEffect: '',
      AaiMotionOutEffect: '',
      AaiMotionLoopEffect: '',
      FontKey: 'douyinmeihaotiBold',
    })
    this.selectType = 'Text'
    this.customList.push({
      id: Id,
      coverType: type
    })
    setTimeout(() => {
      clipIdStore.setClipId(Id)
      console.log(this.playerRef.timeline, 'this.playerRef.timeline')
      const data = {
        ...this.playerRef.timeline,
        VideoTracks: this.playerRef.timeline.VideoTracks.map(_li => {
          if (_li.Type === 'Subtitle' || _li.Type === 'SubTitle') {
            _li.VideoTrackClips.forEach(_item => {
              if (_item.Id === Id) {
                _item.Font = _item.FontKey
                _item.FontUrl = url
              }
            })
          }
          return _li
        })
      }
      this.timeline.timeline = data
    }, 1000)
  }
  public getLayers() {
    // 先合并所有 VideoTrackClips
    let allClips: any[] = [];
    console.log(this.playerRef, 'playerRef数据')
    if (this.playerRef?.timeline.VideoTracks?.length > 0) {
      this.playerRef?.timeline.VideoTracks.forEach((item) => {
        if (Array.isArray(item.VideoTrackClips)) {
          allClips = allClips.concat(item.VideoTrackClips);
        }
      });
    }
    // 再统一按 TrackId 从小到大排序
    // allClips.sort((a, b) => a.TrackId - b.TrackId);
    return allClips
  }
  public getTexts() {
    if (!this.playerRef) {
      return []
    }
    let allClips: any[] = [];
    if (this.playerRef.timeline.VideoTracks?.length > 0) {
      const data = this.playerRef.timeline.VideoTracks.filter(item => ((item.Type === 'Subtitle' || item.Type === 'SubTitle') && item.VideoTrackClips?.length > 0))
      data.forEach(item => {
        if (Array.isArray(item.VideoTrackClips)) {
          allClips = allClips.concat(item.VideoTrackClips);
        }
      })
    }
    return allClips
  }
  public getImages() {
    if (!this.playerRef) {
      return []
    }
    let allClips: any[] = [];
    if (this.playerRef.timeline.VideoTracks?.length > 0) {
      const data = this.playerRef.timeline.VideoTracks.filter(item => ((item.Type === 'Video' || item.Type === 'Image') && item.VideoTrackClips?.length > 0))
      data.forEach(item => {
        const res = item.VideoTrackClips.filter(item => item.Type === 'Image')
        if (Array.isArray(res)) {
          allClips = allClips.concat(res);
        }
      })
    }
    return allClips
  }
  public updateClipHiddenByClipId() {
    const curClipId = clipIdStore.getClipId();
    if (!this.timeline?.timeline?.VideoTracks) return;
    this.timeline.timeline.VideoTracks.forEach(track => {
      if (Array.isArray(track.VideoTrackClips)) {
        track.VideoTrackClips.forEach(clip => {
          if (clip.Id > curClipId) {
            clip.hidden = true;
          } else {
            clip.hidden = false;
          }
        });
      }
    });
  }

  // 更新clip
  public updateClip(clipId: number, update: any) {
    this.playerRef.updateClip(clipId, (value) => {
      console.log(value, 'value', update, 'update');
      return {
        ...value,
        ...update
      }
    });
  }
  // 根据clipId获取clip
  public getClipById(clipId: number) {
    return this.playerRef.getClip(clipId);
  }

  // 删除clip
  public removeClip(clipId: number) {
    this.playerRef.removeClip(clipId);
  }
}

const store = new YsVideoStore();
export default store;
